import { render, staticRenderFns } from "./applyDetails.vue?vue&type=template&id=0e96ffb2&scoped=true&"
import script from "./applyDetails.vue?vue&type=script&lang=js&"
export * from "./applyDetails.vue?vue&type=script&lang=js&"
import style0 from "./applyDetails.vue?vue&type=style&index=0&id=0e96ffb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96ffb2",
  null
  
)

export default component.exports